/* ============================================================
   bb-wp-options.js: WRAPPING PAPER TEMPLATE ONLY
   Loaded only by sections/bb-wp-options.liquid.
   - Finish toggle: updates the hidden "Finish" property.
     FINISH VARIANTS MODE (Oct 2026): if the Size option values carry
     the finish as a suffix ("3 ft Roll - Glossy", "3 ft Roll - Matte"),
     the toggle also picks the matching real variant, so each finish
     has its own SKU for Printify. The page still shows 3 size rows
     (suffix hidden, other finish's rows hidden). If no value has a
     finish suffix, nothing changes (old behaviour).
   - Number of Pets: updates the hidden "Number of Pets" property
     and the hidden Additional Pets add-on row. The existing
     bb-product.js then handles price + add to cart (unchanged).
   - Keeps the "Complete the set" header text ignoring the hidden
     add-on row.
   - Upload button text follows the pet count
     ("Upload 3 Pet Photos"); 1 pet keeps Uploadly's own text.
   ============================================================ */
(function () {
  if (window.BBWrapOptions) return;

  function getRoot() { return document.querySelector('[data-bb-product-root]'); }

  /* ---------- Finish ---------- */
  var SEP = ' - ';

  function finishNames() {
    var out = [];
    document.querySelectorAll('[data-bb-wp-finish]').forEach(function (b) {
      var v = b.getAttribute('data-bb-wp-finish');
      if (v && out.indexOf(v) === -1) out.push(v);
    });
    return out;
  }

  /* Split "3 ft Roll - Glossy" into { base: "3 ft Roll", finish: "Glossy" }. Null if no finish suffix. */
  function splitVal(val) {
    if (!val) return null;
    var names = finishNames();
    for (var i = 0; i < names.length; i++) {
      var suf = SEP + names[i];
      if (val.length > suf.length && val.slice(-suf.length).toLowerCase() === suf.toLowerCase()) {
        return { base: val.slice(0, -suf.length), finish: names[i] };
      }
    }
    return null;
  }

  /* All size buttons whose value carries a finish suffix (empty = old mode). */
  function finishRows() {
    var root = getRoot();
    if (!root) return [];
    var rows = [];
    root.querySelectorAll('button.bb-vopt[data-bb-vopt][data-val]').forEach(function (b) {
      if (splitVal(b.getAttribute('data-val'))) rows.push(b);
    });
    return rows;
  }

  function setToggleUI(finish) {
    document.querySelectorAll('.bb-wp-finish').forEach(function (step) {
      step.querySelectorAll('[data-bb-wp-finish]').forEach(function (b) {
        var on = b.getAttribute('data-bb-wp-finish') === finish;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var input = step.querySelector('[data-bb-wp-finish-input]');
      if (input) input.value = finish;
    });
  }

  /* Make the page match the selected variant: show only the current finish's rows,
     hide the suffix in row names and in the step's "chosen" label, sync the toggle. */
  var syncing = false;
  function syncFinishVariants() {
    var rows = finishRows();
    if (!rows.length || syncing) return;
    syncing = true;
    try {
      var current = null;
      rows.forEach(function (b) { if (b.classList.contains('is-on')) current = splitVal(b.getAttribute('data-val')); });
      if (!current) {
        var on = document.querySelector('.bb-wp-finish [data-bb-wp-finish].is-on');
        current = { base: null, finish: on ? on.getAttribute('data-bb-wp-finish') : splitVal(rows[0].getAttribute('data-val')).finish };
      }
      rows.forEach(function (b) {
        var parts = splitVal(b.getAttribute('data-val'));
        b.style.display = parts.finish === current.finish ? '' : 'none';
        var nm = b.querySelector('.bb-size-row__nm');
        if (nm && nm.textContent !== parts.base) nm.textContent = parts.base;
        var step = b.closest('.bb-step');
        var chosen = step && step.querySelector('[data-bb-chosen]');
        if (chosen) {
          var c = splitVal((chosen.textContent || '').trim());
          if (c) chosen.textContent = c.base;
        }
      });
      setToggleUI(current.finish);
      var root = getRoot();
      if (root) root.classList.add('bb-wp-fv-ready');
    } finally {
      syncing = false;
    }
  }

  function onFinishClick(btn) {
    var step = btn.closest('.bb-wp-finish');
    if (!step) return;
    var want = btn.getAttribute('data-bb-wp-finish');
    var rows = finishRows();

    if (rows.length) {
      /* Finish variants mode: click the hidden row with the same size + the new finish.
         bb-product.js then switches the variant, price, URL and cart line as usual. */
      var base = null;
      rows.forEach(function (b) { if (b.classList.contains('is-on')) base = splitVal(b.getAttribute('data-val')).base; });
      var target = null;
      rows.forEach(function (b) {
        var parts = splitVal(b.getAttribute('data-val'));
        if (!target && parts.finish === want && (base === null || parts.base === base)) target = b;
      });
      if (target) target.click();
      setToggleUI(want);
      setTimeout(syncFinishVariants, 0);
      return;
    }

    /* Old mode: note only */
    setToggleUI(want);
  }

  /* ---------- "Complete the set" header: ignore the hidden pets row ---------- */
  function fixExtrasChosen() {
    var root = getRoot();
    if (!root) return;
    var chosen = root.querySelector('[data-bb-extras-chosen]') || root.querySelector('.bb-step--extras .bb-step__chosen');
    var picked = root.querySelectorAll('[data-bb-extra]:not([data-bb-wp-extra]) input[data-bb-extra-cb]:checked');
    if (chosen) {
      if (picked.length === 0) {
        chosen.textContent = chosen.getAttribute('data-default') || 'Optional';
      } else if (picked.length === 1) {
        var name = picked[0].closest('[data-bb-extra]').getAttribute('data-bb-extra-name');
        chosen.textContent = name || '1 added';
      } else {
        chosen.textContent = picked.length + ' added';
      }
    }
    var step = root.querySelector('.bb-step--extras, .bb-step[data-step="extras"]');
    if (step) step.classList.toggle('is-done', picked.length > 0);
  }

  /* ---------- Upload button text ---------- */
  var uploadOriginal = null;          // Uploadly's own button text, read once
  var ourLabels = {};                 // labels this script has set
  var currentPets = 1;

  function uploadLabelFor(n) {
    if (n <= 1) return uploadOriginal;
    var step = document.querySelector('.bb-wp-pets');
    var tpl = (step && step.getAttribute('data-upload-many')) || 'Upload [n] Pet Photos';
    return tpl.replace('[n]', n);
  }

  function applyUploadLabel() {
    var root = getRoot();
    if (!root) return;
    var btn = root.querySelector('.uploadcare--widget__button_type_open');
    if (!btn) return;
    var txt = (btn.textContent || '').trim();
    if (uploadOriginal === null) {
      if (!txt) return;
      uploadOriginal = txt;
    }
    /* Only touch the button while it shows the start text (never "Change File" etc.) */
    if (txt !== uploadOriginal && !ourLabels[txt]) return;
    var want = uploadLabelFor(currentPets);
    if (!want || txt === want) return;
    ourLabels[want] = true;
    btn.textContent = want;
  }

  function watchUploader() {
    var root = getRoot();
    if (!root || !window.MutationObserver) return;
    var pending = false;
    var obs = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; applyUploadLabel(); }, 60);
    });
    obs.observe(root, { childList: true, subtree: true, characterData: true });
  }

  /* ---------- Number of Pets ---------- */
  function onPetsClick(btn) {
    if (btn.disabled) return;
    var step = btn.closest('.bb-wp-pets');
    if (!step) return;
    var n = parseInt(btn.getAttribute('data-bb-wp-pets'), 10) || 1;
    currentPets = n;

    step.querySelectorAll('[data-bb-wp-pets]').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var one = step.getAttribute('data-word-one') || 'Pet';
    var many = step.getAttribute('data-word-many') || 'Pets';
    var chosen = step.querySelector('[data-bb-wp-pets-chosen]');
    if (chosen) chosen.textContent = n + ' ' + (n === 1 ? one : many);

    var input = step.querySelector('[data-bb-wp-pets-input]');
    if (input) input.value = String(n);

    var extra = step.querySelector('[data-bb-wp-extra]');
    var cb = extra && extra.querySelector('[data-bb-extra-cb]');
    if (extra && cb) {
      if (n > 1) {
        extra.setAttribute('data-bb-extra-variant', btn.getAttribute('data-variant') || '');
        extra.setAttribute('data-bb-extra-price', btn.getAttribute('data-price') || '0');
        cb.checked = true;
      } else {
        extra.setAttribute('data-bb-extra-variant', '');
        extra.setAttribute('data-bb-extra-price', '0');
        cb.checked = false;
      }
      /* bb-product.js listens for this and refreshes the Add to Cart + sticky price */
      cb.dispatchEvent(new Event('change', { bubbles: true }));
    }
    fixExtrasChosen();
    applyUploadLabel();
  }

  /* ---------- Wiring ---------- */
  var wired = false;
  function init() {
    if (!wired) {
      wired = true;
      document.addEventListener('click', function (e) {
        var f = e.target.closest && e.target.closest('[data-bb-wp-finish]');
        if (f) { e.preventDefault(); onFinishClick(f); return; }
        var p = e.target.closest && e.target.closest('[data-bb-wp-pets]');
        if (p) { e.preventDefault(); onPetsClick(p); return; }
        /* Any Style / Color / Size click: re-sync finish rows after bb-product.js has run */
        if (e.target.closest && e.target.closest('button.bb-vopt[data-bb-vopt]')) setTimeout(syncFinishVariants, 0);
      });
      document.addEventListener('change', function (e) {
        if (e.target && e.target.matches && e.target.matches('select.bb-vopt-select')) setTimeout(syncFinishVariants, 0);
      });
      /* Runs after bb-product.js's own listener (that one sits on the checkbox itself) */
      document.addEventListener('change', function (e) {
        if (e.target && e.target.matches && e.target.matches('[data-bb-extra-cb]')) fixExtrasChosen();
      });
      watchUploader();
    }
    /* Sync state with whatever is selected right now (also after a theme editor re-render) */
    var on = document.querySelector('.bb-wp-pets [data-bb-wp-pets].is-on');
    currentPets = on ? (parseInt(on.getAttribute('data-bb-wp-pets'), 10) || 1) : 1;
    syncFinishVariants();
    fixExtrasChosen();
    applyUploadLabel();
  }

  window.BBWrapOptions = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
